/** Whole days remaining until an ISO date, floored at 0. Invalid dates return 0. */
export function daysRemaining(iso: string): number {
  const ms = new Date(iso).getTime();
  if (isNaN(ms)) return 0;
  return Math.max(0, Math.ceil((ms - Date.now()) / 86400000));
}

/** Formats an ISO date as "1 January 2026" (en-AU). Invalid dates return an empty string. */
export function formatDate(iso: string): string {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' });
}
